import * as Sentry from "@sentry/react";
import React from "react";
import i18nService from "./core/i18n/i18n";

// styles
import "sanitize.css";
import "./core/styles/flex.scss";
import "./core/styles/form.scss";
import "./core/styles/global.scss";
import "./core/styles/grid.scss";
import "./core/styles/modal.scss";
import "./core/styles/styles.scss";
import "./core/styles/table.scss";
import "./core/styles/typography.scss";
import "./core/styles/mixins/paddingMarginMixin.scss";
import "./core/styles/app-tokens.css";

import { createRoot } from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import { Router } from "./Router";

import i18n, { defaultNS } from "./core/i18n/i18n";

// i18n
i18nService.init();

// Sentry instrumentation
if (import.meta.env.VITE_APP_SENTRY_DSN !== "false") {
  Sentry.init({
    dsn: import.meta.env.VITE_APP_SENTRY_DSN,
    environment: import.meta.env.VITE_APP_ENVIRONMENT,
    release: import.meta.env.VITE_SENTRY_RELEASE,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        maskAllInputs: true,
        blockAllMedia: true,
      }),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 0.3,
    tracePropagationTargets: [import.meta.env.VITE_APP_BACKEND_URI, "localhost"],
    sendDefaultPii: false,
  });
}

const container = document.getElementById("root");
const root = createRoot(container as Element);
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary>
      <I18nextProvider i18n={i18n} defaultNS={defaultNS}>
        <Router />
      </I18nextProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
